import React from "react";
import DynamicTable from "./DynamicTable";
import Navbar from "../components/Navbar";
import { toast, ToastContainer } from "react-toastify";
import RichTextComponent from "../components/RichTextComponent";

const tableData = [
  {
    type: "TemplateOne",
    title: "Раздел 1. Сведения о количестве граждан",
    headers: [
      { text: "№ строки", rowSpan: 1, colSpan: 1 },
      { text: "Содержание", rowSpan: 1, colSpan: 1 },
      { text: "Всего граждан", rowSpan: 1, colSpan: 1 },
      { text: "Из них граждан сельских районов", rowSpan: 1, colSpan: 1 },
    ],
    rows: [
      {
        rowNumber: 1,
        description: "Описание 1",
        values: ["sr5_1_3", "sr5_1_4"],
      },
    ],
    rules: [{ type: "disabled", target: "sr5_1_3" }],
  },
  {
    type: "TemplateTwo",
    title: "Раздел ОТД",
    headers: [
      [
        { text: "№ строки", rowSpan: 2, colSpan: 1 },
        { text: "Средства защиты", rowSpan: 2, colSpan: 1 },
        { text: "Заявлено", rowSpan: 1, colSpan: 2 },
        { text: "Удовлетворено", rowSpan: 1, colSpan: 2 },
      ],
      [
        { text: "Всего", rowSpan: 1, colSpan: 1 },
        { text: "Сельские районы", rowSpan: 1, colSpan: 1 },
        { text: "Всего", rowSpan: 1, colSpan: 1 },
        { text: "Сельские районы", rowSpan: 1, colSpan: 1 },
      ],
    ],
    rows: [
      {
        rowNumber: 22,
        description: "Запросы о предоставлении сведений",
        values: ["sr5_22_3", "sr5_22_4", "sr5_22_5", "sr5_22_6"],
      },
    ],
    rules: [
      { type: "sum", target: "sr5_22_3", sources: ["sr5_22_4", "sr5_22_5"] },
    ],
  },
  {
    type: "TemplateThree",
    title: "Раздел I. Юридическая помощь",
    headers: [
      [
        { text: "№ строки", rowSpan: 2, colSpan: 1 },
        { text: "Содержание", rowSpan: 2, colSpan: 1 },
        { text: "Всего", rowSpan: 2, colSpan: 1 },
        { text: "В том числе", rowSpan: 1, colSpan: 3 },
      ],
      [
        { text: "ЖК", rowSpan: 1, colSpan: 1 },
        { text: "ЛК", rowSpan: 1, colSpan: 1 },
        { text: "СД", rowSpan: 1, colSpan: 1 },
      ],
    ],
    rows: [
      {
        rowNumber: 1,
        description: "Юридическая помощь",
        values: ["sr1_1", "sr1_2", "sr1_3", "sr1_4"],
      },
    ],
    rules: [{ type: "gte", target: "sr1_1", sources: ["sr1_2", "sr1_3"] }],
  },
];

const Form = (props) => {
  const period_id = props.period_id;
  const form_id = props.form.id;
  const table = props.table;
  const form = props.form;
  const handleSubmit = (formData) => {
    // Преобразуем formData в массив объектов
    const transformedData = Object.keys(formData).map((key) => ({
      [key]: formData[key],
    }));

    // Подмешиваем period_id и form_id
    const dataToSend = {
      period_id: period_id, // Добавляем period_id
      form_id: form_id, // Добавляем form_id
      data: transformedData, // Передаем массив объектов
    };

    console.log("Отправка данных:", dataToSend);
    fetch("/reports", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataToSend),
    })
      .then(async (response) => {
        if (response.ok) {
          // Извлекаем данные из ответа
          const responseData = await response.json();

          // Теперь можем использовать responseData.id
          window.location.href = `/reports/${responseData.id}/edit`;
          toast.success("Форма успешно отправлена!");
        } else {
          const errorData = await response.json();
          toast.error(
            `Ошибка при отправке формы: ${
              errorData.error || "Неизвестная ошибка"
            }`
          );
        }
      })
      .catch((error) => {
        console.error("Ошибка сети:", error);
        toast.error("Ошибка сети. Попробуйте снова.");
      });
  };

  return (
    <div className="min-h-full">
      <ToastContainer />
      <div className="pb-32">
        <Navbar props={props} />
      </div>

      {/* Основной контент */}
      <main className="-mt-32">
        <div className="mx-auto container max-w-screen-2xl px-4 pb-12">
          <div className="overflow-scroll  ">
            <header className="flex mt-20 flex-col md:flex-row justify-between items-center border-b border-gray-300 pb-4 mb-5">
              <div className="text-left md:ml-4">
                <p className="text-sm md:text-base font-semibold"></p>
              </div>
              <div className="text-right md:mr-4 mt-4 md:mt-0">
                <RichTextComponent richText={form.header} />
              </div>
            </header>
            <main className="mb-5">
              <h1 className="text-center text-lg md:text-xl font-bold mb-6">
                {form.form_name}
              </h1>
              <div className="text-sm md:text-base space-y-2">
                <RichTextComponent richText={form.information} />
              </div>
            </main>
            <DynamicTable sections={table} onSubmit={handleSubmit} />
          </div>
        </div>
      </main>
    </div>
  );
};

export default Form;
